(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("laxar"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define(["laxar", "moment"], factory);
	else if(typeof exports === 'object')
		exports["laxar-uikit"] = factory(require("laxar"), require("moment"));
	else
		root["laxar-uikit"] = factory(root["laxar"], root["moment"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_laxar__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_laxar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_laxar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__moment_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number_formats__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatter__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parser__ = __webpack_require__(7);
/**
 * Copyright 2014 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */







function create() {
   var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

   function options(optionalOptions) {
      return __WEBPACK_IMPORTED_MODULE_0_laxar__["object"].options(optionalOptions, defaults);
   }

   return {
      options: options,
      formatter: Object.assign({}, __WEBPACK_IMPORTED_MODULE_3__formatter__, {
         create: function create(type, optionalOptions) {
            return __WEBPACK_IMPORTED_MODULE_3__formatter__["create"](type, options(optionalOptions));
         }
      }),
      parser: Object.assign({}, __WEBPACK_IMPORTED_MODULE_4__parser__, {
         create: function create(type, optionalOptions) {
            return __WEBPACK_IMPORTED_MODULE_4__parser__["create"](type, options(optionalOptions));
         }
      }),
      localized: function localized(i18n) {
         var momentFormat = i18n.localize(__WEBPACK_IMPORTED_MODULE_1__moment_formats__["a" /* default */]);
         var numberFormat = i18n.localize(__WEBPACK_IMPORTED_MODULE_2__number_formats__["a" /* default */]);

         return create({
            dateFormat: momentFormat.date,
            timeFormat: momentFormat.time,
            decimalSeparator: numberFormat.d,
            groupingSeparator: numberFormat.g
         });
      }
   };
}

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatter", function() { return formatter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parser", function() { return parser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "options", function() { return options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "localized", function() { return localized; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_uikit__ = __webpack_require__(2);
/**
 * Copyright 2014-2017 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */

/**
 * Provides utilities for localized parsing and formatting of values in LaxarJS applications.
 *
 * @module laxar-uikit
 */



var _create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_uikit__["a" /* create */])(),
    formatter = _create.formatter,
    parser = _create.parser,
    options = _create.options,
    localized = _create.localized;



/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["create"] = create;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_laxar__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_laxar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_laxar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2014 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
/**
 * A module for formatting values of different types to strings.
 *
 * @module formatter
 */



var ISO_DATE_FORMAT = 'YYYY-MM-DD';
var ISO_TIME_FORMAT = 'HH:mm:ss';
var ISO_FULL_FORMAT_MIN_LENGTH = (ISO_DATE_FORMAT + 'T' + ISO_TIME_FORMAT).length;
var NUMERICAL_STRING_REGEXP = /^([+-])?\d+(\.\d+)?$/;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

var formatters = {

   string: function string(options, str) {
      return str == null ? '' : '' + str;
   },

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   decimal: function decimal(options, value) {
      if (value == null) {
         return '';
      }

      var number = typeof value === 'string' && NUMERICAL_STRING_REGEXP.exec(value) ? parseFloat(value) : value;

      if (typeof number !== 'number') {
         throw new TypeError('Expected argument of type number, but got "' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '". Value: ' + value);
      }

      var numberParts = toPrecision(number, options.decimalPlaces, options.decimalTruncation).split('.');
      var integerPart = numberParts[0].replace(/^[+-]/, '');
      var fractionPart = numberParts[1] || '';

      var integerLength = integerPart.length - 1;
      var front = integerPart.split('').reduce(function (str, digit, index) {
         var pos = integerLength - index;
         return str + digit + (pos % 3 === 0 && pos !== 0 ? options.groupingSeparator : '');
      }, number < 0 ? '-' : '');

      return front + (fractionPart.length > 0 ? options.decimalSeparator + fractionPart : '');
   },


   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   integer: function integer(options, number) {
      var integerOptions = __WEBPACK_IMPORTED_MODULE_0_laxar__["object"].options({ decimalPlaces: 0 }, options);
      return formatters.decimal(integerOptions, number);
   },


   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   date: createDateTimeFormatter('date', ISO_DATE_FORMAT),

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   time: createDateTimeFormatter('time', ISO_TIME_FORMAT)
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function createDateTimeFormatter(type, inputFormat) {
   return function (options, value) {
      if (value == null) {
         return '';
      }

      if (value instanceof Date) {
         return format(__WEBPACK_IMPORTED_MODULE_1_moment___default()(value));
      }

      if (typeof value !== 'string') {
         throw argumentError(value);
      }

      var useInputFormat = value.length < ISO_FULL_FORMAT_MIN_LENGTH;
      var momentTime = value.toLowerCase() === 'now' ? __WEBPACK_IMPORTED_MODULE_1_moment___default()() : __WEBPACK_IMPORTED_MODULE_1_moment___default()(value, useInputFormat ? inputFormat : undefined, useInputFormat || undefined);

      if (!momentTime.isValid()) {
         throw argumentError(value);
      }

      return format(momentTime);

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      function format(momentTime) {
         return momentTime.format(options[type + 'Format']);
      }

      function argumentError(value) {
         return new TypeError('Expected argument to be a Date object, the string "NOW", or an ISO-8601 string ' + ('(full, or ' + type + ' as ' + inputFormat + '), but got "' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '". Value: ' + value));
      }
   };
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function toPrecision(number, places, truncation) {
   // Define a maximum precision for truncation=NONE, taking into account 32bit machine limits.
   // We cannot use Number.toFixed because of rounding errors in MSIE8.
   var MAX_SIGNIFICANT_PLACES = 14;

   var actualPlaces = truncation === 'NONE' ? MAX_SIGNIFICANT_PLACES : places;

   if (actualPlaces === 0) {
      return '' + Math.round(number);
   }

   var multiplier = Math.pow(10, actualPlaces);
   var str = '' + Math.round(number * multiplier) / multiplier;

   // Detect and avoid scientific notation for numbers x where |x| << 10^(-5)
   // A heuristic is used to avoid unnecessary string operations for "regular" numbers
   var absNumber = Math.abs(number);
   if (absNumber < 0.0001) {
      var exponent = parseInt(str.split('e-')[1], 10);
      if (exponent) {
         var base = '' + Math.pow(10, exponent - 1) * Math.round(absNumber * multiplier) / multiplier;
         str = (number < 0 ? '-' : '') + '0.' + (zeros(exponent - 1) + base.substring(2));
      }
   }

   if (truncation === 'BOUNDED' || truncation === 'NONE') {
      return str;
   }

   var tmp = str.split('.');
   if (tmp.length === 1) {
      return str + '.' + zeros(actualPlaces);
   }

   return str + zeros(actualPlaces - tmp[1].length);
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function zeros(count) {
   return new Array(count + 1).join('0');
}

/**
 * Creates a function to format values of a given type to a configurable string representations. If a
 * value has the wrong type to be formatted using the configured `type`, the format function throws a
 * `TypeError`.
 *
 * When formatting values for display as date or time, the full datetime should always be passed if
 * available; either as a Date-object, or as a full [ISO 8601](http://en.wikipedia.org/wiki/ISO_8601) string,
 * including timezone. To format a date without time or to format a time-of-day, the respective ISO-formatted
 * portions can be passed instead, without TZ information.
 * Finally, the string "NOW" can be used which always results in the current local date/time.
 *
 * Acceptable *input* values for
 *    - date: `"NOW", new Date(), "2014-03-22T14:52:03.444Z", "2014-03-22"`
 *    - time: `"NOW", new Date(), "2014-03-22T14:52:03.444Z", "14:52:03"`
 *
 * The formatter for type `'string'` simply triggers the `toString` method of the given argument, while
 * `null` and `undefined` result in the empty string.
 *
 * @param {String} type
 *    the value type to create the formatter for. Can be one of `'string'`, `'integer'`, `'decimal'`,
 *    `'date'` and `'time'`
 * @param {Object} [optionalOptions]
 *    different options depending on the selected `type`
 * @param {String} optionalOptions.groupingSeparator
 *    the character used for thousands separation. Applicable to types `decimal` and `integer` only.
 *    Default: `','`
 * @param {String} optionalOptions.decimalSeparator
 *    the character used for fraction part separation. Applicable to type `decimal` only.
 *    Default: `'.'`
 * @param {Number} optionalOptions.decimalPlaces
 *    number of decimal places to keep in the formatted value. Applies rounding if necessary. Applicable
 *    to type `decimal` only.
 *    Default: `2`
 * @param {String} optionalOptions.decimalTruncation
 *    how to treat insignificant decimal places (trailing zeros):
 *    - `'FIXED'`: uses a fraction length of exactly `decimalPlaces`, padding with zeros
 *    - `'BOUNDED'`: uses a fraction length up to `decimalPlaces`, no padding
 *    - `'NONE'`: unbounded fraction length (only limited by numeric precision), no padding
 *    Applicable to type `decimal` only.
 *    Default: `'FIXED'`
 * @param {String} optionalOptions.dateFormat
 *    the format used to format date values with. Applicable to type `date` only.
 *    Default: `'M/D/YYYY'`
 * @param {String} optionalOptions.timeFormat
 *    the format used to format time values with. Applicable to type `time` only.
 *    Default: `'H:m'`
 *
 * @return {Function}
 *    the format function as described above. Throws a `TypeError` if the provided value cannot be
 *    formatted using the configured `type`
 */
function create(type, optionalOptions) {
   var options = __WEBPACK_IMPORTED_MODULE_0_laxar__["object"].options(optionalOptions, {
      groupingSeparator: ',',
      decimalSeparator: '.',
      decimalPlaces: 2,
      decimalTruncation: 'FIXED',
      dateFormat: 'M/D/YYYY',
      timeFormat: 'H:m'
   });
   return formatters[type].bind(formatters, options);
}

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2014 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
/* harmony default export */ __webpack_exports__["a"] = ({
   'en': {
      'date': 'MM/DD/YYYY',
      'time': 'h:mm A'
   },
   'ar-ma': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'ar': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'bg': {
      'date': 'D.MM.YYYY',
      'time': 'H:mm'
   },
   'br': {
      'date': 'DD/MM/YYYY',
      'time': 'h[e]mm A'
   },
   'bs': {
      'date': 'DD. MM. YYYY',
      'time': 'H:mm'
   },
   'ca': {
      'date': 'DD/MM/YYYY',
      'time': 'H:mm'
   },
   'cs': {
      'date': 'DD.MM.YYYY',
      'time': 'H:mm'
   },
   'cv': {
      'date': 'DD-MM-YYYY',
      'time': 'HH:mm'
   },
   'da': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'de': {
      'date': 'DD.MM.YYYY',
      'time': 'HH:mm'
   },
   'el': {
      'date': 'DD/MM/YYYY',
      'time': 'h:mm A'
   },
   'en-au': {
      'date': 'DD/MM/YYYY',
      'time': 'h:mm A'
   },
   'en-ca': {
      'date': 'YYYY-MM-DD',
      'time': 'h:mm A'
   },
   'en-gb': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'eo': {
      'date': 'YYYY-MM-DD',
      'time': 'HH:mm'
   },
   'es': {
      'date': 'DD/MM/YYYY',
      'time': 'H:mm'
   },
   'et': {
      'date': 'DD.MM.YYYY',
      'time': 'H:mm'
   },
   'eu': {
      'date': 'YYYY-MM-DD',
      'time': 'HH:mm'
   },
   'fa': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'fi': {
      'date': 'DD.MM.YYYY',
      'time': 'HH.mm'
   },
   'fr-ca': {
      'date': 'YYYY-MM-DD',
      'time': 'HH:mm'
   },
   'fr': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'gl': {
      'date': 'DD/MM/YYYY',
      'time': 'H:mm'
   },
   'he': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'hi': {
      'date': 'DD/MM/YYYY',
      'time': 'A h:mm बजे'
   },
   'hr': {
      'date': 'DD. MM. YYYY',
      'time': 'H:mm'
   },
   'hu': {
      'date': 'YYYY.MM.DD.',
      'time': 'H:mm'
   },
   'id': {
      'date': 'DD/MM/YYYY',
      'time': 'HH.mm'
   },
   'is': {
      'date': 'DD/MM/YYYY',
      'time': 'H:mm'
   },
   'it': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'ja': {
      'date': 'YYYY/MM/DD',
      'time': 'Ah時m分'
   },
   'ka': {
      'date': 'DD/MM/YYYY',
      'time': 'h:mm A'
   },
   'ko': {
      'date': 'YYYY.MM.DD',
      'time': 'A h시 mm분'
   },
   'lt': {
      'date': 'YYYY-MM-DD',
      'time': 'HH:mm'
   },
   'lv': {
      'date': 'DD.MM.YYYY',
      'time': 'HH:mm'
   },
   'ml': {
      'date': 'DD/MM/YYYY',
      'time': 'A h:mm -നു'
   },
   'mr': {
      'date': 'DD/MM/YYYY',
      'time': 'A h:mm वाजता'
   },
   'ms-my': {
      'date': 'DD/MM/YYYY',
      'time': 'HH.mm'
   },
   'nb': {
      'date': 'DD.MM.YYYY',
      'time': 'H.mm'
   },
   'ne': {
      'date': 'DD/MM/YYYY',
      'time': 'Aको h:mm बजे'
   },
   'nl': {
      'date': 'DD-MM-YYYY',
      'time': 'HH:mm'
   },
   'nn': {
      'date': 'DD.MM.YYYY',
      'time': 'HH:mm'
   },
   'pl': {
      'date': 'DD.MM.YYYY',
      'time': 'HH:mm'
   },
   'pt-br': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'pt': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'ro': {
      'date': 'DD/MM/YYYY',
      'time': 'H:mm'
   },
   'ru': {
      'date': 'DD.MM.YYYY',
      'time': 'HH:mm'
   },
   'sk': {
      'date': 'DD.MM.YYYY',
      'time': 'H:mm'
   },
   'sl': {
      'date': 'DD. MM. YYYY',
      'time': 'H:mm'
   },
   'sq': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'sv': {
      'date': 'YYYY-MM-DD',
      'time': 'HH:mm'
   },
   'th': {
      'date': 'YYYY/MM/DD',
      'time': 'H นาฬิกา m นาที'
   },
   'tr': {
      'date': 'DD.MM.YYYY',
      'time': 'HH:mm'
   },
   'tzm-la': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'tzm': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'uk': {
      'date': 'DD.MM.YYYY',
      'time': 'HH:mm'
   },
   'uz': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'vn': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'zh-cn': {
      'date': 'YYYY年MMMD日',
      'time': 'Ah点mm'
   },
   'zh-tw': {
      'date': 'YYYY年MMMD日',
      'time': 'Ah點mm'
   }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2014 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
/* harmony default export */ __webpack_exports__["a"] = ({
   'en': {
      'g': ',',
      'd': '.'
   },
   'ar-ma': {
      'g': '٬',
      'd': '٫'
   },
   'ar': {
      'g': '٬',
      'd': '٫'
   },
   'bg': {
      'g': ' ',
      'd': ','
   },
   'br': {
      'g': ',',
      'd': '.'
   },
   'bs': {
      'g': ',',
      'd': '.'
   },
   'ca': {
      'g': '.',
      'd': ','
   },
   'cs': {
      'g': ' ',
      'd': ','
   },
   'cv': {
      'g': ',',
      'd': '.'
   },
   'da': {
      'g': '.',
      'd': ','
   },
   'de': {
      'g': '.',
      'd': ','
   },
   'el': {
      'g': '.',
      'd': ','
   },
   'en-au': {
      'g': ',',
      'd': '.'
   },
   'en-ca': {
      'g': ',',
      'd': '.'
   },
   'en-gb': {
      'g': ',',
      'd': '.'
   },
   'eo': {
      'g': ',',
      'd': '.'
   },
   'es': {
      'g': '.',
      'd': ','
   },
   'et': {
      'g': ' ',
      'd': ','
   },
   'eu': {
      'g': ',',
      'd': '.'
   },
   'fa': {
      'g': '٬',
      'd': '٫'
   },
   'fi': {
      'g': ' ',
      'd': ','
   },
   'fr-ca': {
      'g': ' ',
      'd': ','
   },
   'fr': {
      'g': ' ',
      'd': ','
   },
   'gl': {
      'g': ',',
      'd': '.'
   },
   'he': {
      'g': ',',
      'd': '.'
   },
   'hi': {
      'g': ',',
      'd': '.'
   },
   'hr': {
      'g': '.',
      'd': ','
   },
   'hu': {
      'g': ' ',
      'd': ','
   },
   'id': {
      'g': '.',
      'd': ','
   },
   'is': {
      'g': ',',
      'd': '.'
   },
   'it': {
      'g': '.',
      'd': ','
   },
   'ja': {
      'g': ',',
      'd': '.'
   },
   'ka': {
      'g': ',',
      'd': '.'
   },
   'ko': {
      'g': ',',
      'd': '.'
   },
   'lt': {
      'g': '.',
      'd': ','
   },
   'lv': {
      'g': ' ',
      'd': ','
   },
   'ml': {
      'g': ',',
      'd': '.'
   },
   'mr': {
      'g': ',',
      'd': '.'
   },
   'ms-my': {
      'g': ',',
      'd': '.'
   },
   'nb': {
      'g': ' ',
      'd': ','
   },
   'ne': {
      'g': ',',
      'd': '.'
   },
   'nl': {
      'g': '.',
      'd': ','
   },
   'nn': {
      'g': ',',
      'd': '.'
   },
   'pl': {
      'g': ' ',
      'd': ','
   },
   'pt-br': {
      'g': '.',
      'd': ','
   },
   'pt': {
      'g': '.',
      'd': ','
   },
   'ro': {
      'g': '.',
      'd': ','
   },
   'ru': {
      'g': ' ',
      'd': ','
   },
   'sk': {
      'g': ' ',
      'd': ','
   },
   'sl': {
      'g': '.',
      'd': ','
   },
   'sq': {
      'g': ',',
      'd': '.'
   },
   'sv': {
      'g': ' ',
      'd': ','
   },
   'th': {
      'g': ',',
      'd': '.'
   },
   'tr': {
      'g': '.',
      'd': ','
   },
   'tzm-la': {
      'g': ',',
      'd': '.'
   },
   'tzm': {
      'g': ',',
      'd': '.'
   },
   'uk': {
      'g': ' ',
      'd': ','
   },
   'uz': {
      'g': ',',
      'd': '.'
   },
   'vn': {
      'g': ',',
      'd': '.'
   },
   'zh-cn': {
      'g': ',',
      'd': '.'
   },
   'zh-tw': {
      'g': ',',
      'd': '.'
   }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["success"] = success;
/* harmony export (immutable) */ __webpack_exports__["error"] = error;
/* harmony export (immutable) */ __webpack_exports__["create"] = create;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_laxar__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_laxar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_laxar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/**
 * Copyright 2014 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
/**
 * A module for parsing strings to different value types.
 *
 * @module parser
 */



var ISO_DATE_FORMAT = 'YYYY-MM-DD';
var ISO_TIME_FORMAT = 'HH:mm:ss';
var NUMERIC_VALUE_MATCHER = /^[+-]?[0-9]*(\.[0-9]*)?$/;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

var parsers = {

   string: function string(options, str) {
      return success(str);
   },

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   decimal: function decimal(options, str) {
      var val = ('' + str).trim();

      if (val.length === 0) {
         return success(null);
      }

      if (options.groupingSeparator) {
         while (val.indexOf(options.groupingSeparator) !== -1) {
            val = val.replace(options.groupingSeparator, '');
         }
      }
      val = val.replace(options.decimalSeparator, '.');

      if (NUMERIC_VALUE_MATCHER.exec(val)) {
         var parsed = parseFloat(val);
         if (!isNaN(parsed)) {
            return success(parsed);
         }
      }
      return error();
   },


   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   integer: function integer(options, str) {
      var result = parsers.decimal(options, str);
      if (!result.ok || result.value === null) {
         return result;
      }

      var integerValue = Math.round(result.value);
      if (result.value !== integerValue) {
         return error();
      }

      return success(integerValue);
   },


   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   date: createDateTimeParser('dateFormat', 'dateFallbackFormats', ISO_DATE_FORMAT),

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   time: createDateTimeParser('timeFormat', 'timeFallbackFormats', ISO_TIME_FORMAT)

};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function createDateTimeParser(formatKey, fallbackFormatsKey, isoFormat) {
   return function (options, str) {
      var val = ('' + str).trim();

      if (val.length === 0) {
         return success(null);
      }

      var formats = [options[formatKey]];
      if (options[fallbackFormatsKey] && options[fallbackFormatsKey].length) {
         formats = options[fallbackFormatsKey].concat(formats);
      }

      var mDate = momentParse(str, formats, options);
      return mDate.isValid() ? success(mDate.format(isoFormat)) : error();
   };
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function momentParse(str, formats, options) {
   var origParseTwoDigitYear = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseTwoDigitYear;
   if (options.dateTwoDigitYearWrap > -1 && options.dateTwoDigitYearWrap < 100) {
      __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseTwoDigitYear = function (input) {
         var int = parseInt(input, 10);
         int = isNaN(int) ? 0 : int;
         return int + (int > options.dateTwoDigitYearWrap ? 1900 : 2000);
      };
   }

   try {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(str, formats, true);
   } finally {
      __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseTwoDigitYear = origParseTwoDigitYear;
   }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Creates a successful parsing result. This is useful e.g. when writing tests.
 *
 * @param {*} value
 *    the parsing result
 *
 * @return {Object}
 *    the parsing result object of form `{ ok: true, value: value }`
 */
function success(value) {
   return {
      ok: true,
      value: value
   };
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Creates a failed parsing result. This is useful e.g. when writing tests.
 *
 * @return {Object}
 *    the parsing result object of form `{ ok: false }`
 */
function error() {
   return {
      ok: false
   };
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Creates a function for parsing strings to a value of the given type. The function only accepts the
 * string to parse as argument and returns an object yielding success or failure. The outcome can be
 * read from the object's attribute `ok` which is `true` in case parsing was successful, or `false`
 * otherwise. Additionally, when the string was parsed successfully as the a value of the given type,
 * the parsed value can be found under the attribute `value`.
 *
 * Note that results for types `date` and `time` are not returned as JavaScript type `Date` or wrapped
 * otherwise, but as simple [ISO 8601](http://en.wikipedia.org/wiki/ISO_8601) strings. Thus a possible
 * date would be `'2014-03-12'` and a time value `'16:34:52'`.
 *
 * The parser for type `'string'` will always return a successful result with the given input as the
 * result's value.
 *
 * Example:
 * --------
 * Successful parsing:
 * ```js
 * const parse = parser.create( 'decimal' );
 * parse( '1,435.56' ); // -> { ok: true, value: 1435.56 }
 * ```
 * Failed parsing:
 * ```js
 * const parse = parser.create( 'date' );
 * parse( 'laxar' ); // -> { ok: false }
 * ```
 *
 * @param {String} type
 *    the value type to create the parser for. Can be one of `'string'`, `'integer'`, `'decimal'`,
 *    `'date'` and `'time'`
 * @param {Object} [optionalOptions]
 *    different options depending on the selected `type`
 * @param {String} optionalOptions.groupingSeparator
 *    the character used for thousands separation. Applicable to types `decimal` and `integer` only.
 *    Default: `','`
 * @param {String} optionalOptions.decimalSeparator
 *    the character used for fraction part separation. Applicable to type `decimal` only.
 *    Default: `'.'`
 * @param {String} optionalOptions.dateFormat
 *    the expected format for dates to parse. If the input doesn't match this format, the
 *    `optionalOptions.dateFallbackFormats` are tried. Applicable to type `date` only.
 *    Default: `'M/D/YYYY'`
 * @param {String} optionalOptions.dateFallbackFormats
 *    formats to try, when parsing with the `optionalOptions.dateFormat` failed. Applicable to type
 *    `date` only.
 *    Default: `[ 'M/D/YY' ]`
 * @param {Number} optionalOptions.dateTwoDigitYearWrap
 *    the value to decide when parsing a two digit year, if the resulting year starts with `19` or with
 *    `20`. Any value below or equal to this number results in a year of the form 20xx, whereas any
 *    value above results in a year of the form 19xx. Applicable to type `date` only.
 *    Default: `68`
 * @param {String} optionalOptions.timeFormat
 *    the expected format for times to parse. If the input doesn't match this format, the
 *    `optionalOptions.timeFallbackFormats` are tried. Applicable to type `time` only.
 *    Default: `'H:m'`
 * @param {String} optionalOptions.timeFallbackFormats
 *    formats to try, when parsing with the `optionalOptions.timeFormat` failed. Applicable to type
 *    `time` only.
 *    Default: `[ 'H', 'HHmm' ]`
 *
 * @return {Function}
 *    the parsing function as described above
 */
function create(type, optionalOptions) {
   var options = __WEBPACK_IMPORTED_MODULE_0_laxar__["object"].options(optionalOptions, {
      groupingSeparator: ',',
      decimalSeparator: '.',
      dateFormat: 'M/D/YYYY',
      dateFallbackFormats: ['M/D/YY', 'D.M.YY', 'D.M.YYYY', 'YYYY-M-D'],
      dateTwoDigitYearWrap: 68,
      timeFormat: 'H:m',
      timeFallbackFormats: ['H', 'HHmm']
   });
   return parsers[type].bind({}, options);
}

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// laxar-uikit.js